import { GET_SUB_DATA, DELETE_PLAN, ADD_PLAN, EDIT_PLAN, GET_SUB_SINGLE } from "../actions/types";

const intialstate = {
    loading: false,
    data: [],
    plan: [],
    error: ''
}
const subReducer = (state = intialstate, action) => {
    switch (action.type) {
        case GET_SUB_DATA:
            return {
                ...state,
                loading: true,
                data: action.payload,
                error: ''
            };
        case DELETE_PLAN:
            return {
                ...state,
            };
        case ADD_PLAN:
            return {
                ...state,
                data: action.payload
            };
        case EDIT_PLAN:
            return {
                ...state
            };
        case GET_SUB_SINGLE:
            return {
                ...state,
                plan: action.payload
            };

        default:
            return state
    }
}

export default subReducer
